"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var children_1 = __importDefault(require("./children"));
var TreeNode = /** @class */ (function (_super) {
    __extends(TreeNode, _super);
    function TreeNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TreeNode.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.data, data = _b === void 0 ? {} : _b, path = _a.path, onUpdateData = _a.onUpdateData, onTreeEvent = _a.onTreeEvent, Template = _a.Template, i = _a.i, onDelete = _a.onDelete, onUpdateParent = _a.onUpdateParent;
        var updateMyData = (function (fn) {
            return _this.updateData(fn(_this.props.data));
        }).bind(this);
        var children = children_1.default({
            TreeNode: TreeNode,
            data: data,
            onUpdateData: onUpdateData,
            onTreeEvent: onTreeEvent,
            Template: Template,
            path: path,
            deleteChildAt: function (i) { return _this.updateData(__assign(__assign({}, data), { children: (data.children || []).filter(function (x, j) { return i !== j; }) })); },
            updateMyData: updateMyData,
        });
        return (react_1.default.createElement(Template, { data: data, i: i, updateData: this.updateData.bind(this), treeEvent: this.treeEvent.bind(this), updateParent: onUpdateParent, children: children, deleteMe: onDelete, addChildren: function (children) { return _this.updateData(__assign(__assign({}, data), { children: (data.children || []).concat(children) })); }, isRoot: i === undefined }));
    };
    TreeNode.prototype.updateData = function (node) {
        var _a = this.props, path = _a.path, onUpdateData = _a.onUpdateData;
        onUpdateData(path, node);
    };
    TreeNode.prototype.treeEvent = function (eventStr, obj) {
        var _a = this.props, path = _a.path, onTreeEvent = _a.onTreeEvent;
        onTreeEvent(eventStr, obj, path);
    };
    return TreeNode;
}(react_1.Component));
exports.default = TreeNode;
